import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { createAsyncThunkSafe } from '../../../_base/createAsyncThunkSafe';
import { StateUser } from '../../state_user';

import { DTO_RESPONSE__auth_success } from '@shared/dto/+user/auth/_requests/response_auth_success';
import { DTO_RESPONSE__error } from '@shared/network/DTO_RESPONSE__error';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { try_set_is_authorized } from '../_methods/try_set_is_authorized';

export const remote_user_auth_login_with_magic_link_token = createAsyncThunkSafe<DTO_RESPONSE__auth_success | DTO_RESPONSE__error, string>(
  ENUM__network_event_client_to_server.USER_AUTH_LOGIN_WITH_MAGIC_LINK_TOKEN,
  async (token): Promise<DTO_RESPONSE__auth_success | DTO_RESPONSE__error> => {
    let response = await send_to_server<DTO_RESPONSE__auth_success | DTO_RESPONSE__error>(
      ENUM__network_event_client_to_server.USER_AUTH_LOGIN_WITH_MAGIC_LINK_TOKEN,
      token,
    );

    return response;
  },
);

export function init_remote_user_auth_login_with_magic_link_token(builder: ActionReducerMapBuilder<StateUser>) {
  builder
    .addCase(remote_user_auth_login_with_magic_link_token.pending, state => {})
    .addCase(remote_user_auth_login_with_magic_link_token.rejected, (state, action) => {})
    .addCase(remote_user_auth_login_with_magic_link_token.fulfilled, (state, action: PayloadAction<DTO_RESPONSE__auth_success | DTO_RESPONSE__error>) => {
      try_set_is_authorized(state, action.payload);
    });
}
